var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","id":"modal-school","hide-footer":"","title":!_vm.currentData ? _vm.$t('colleges.new') : _vm.$t('colleges.edit-college')}},[_c('FormCollage',{attrs:{"collegeData":_vm.currentData},on:{"close":function($event){return _vm.$bvModal.hide('modal-school')},"save":_vm.addCollege}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }